import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { verifyMobile } from '@/constants/mobile';

const protectSubscription = (to, from, next) => {
	const subscription_id = store.state.subscriptionDetail.subscription_id;

	if (subscription_id === null) {
		next(false);
	} else {
		next();
	}
}

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		redirect:  { name: "login" }
	},
	{
		path: "/login",
		name: "login",
		meta: {
			depth: 0
		},
		component: () => import(/* webpackChunkName: "login" */ "@/views/web/Login.vue"),
	},
	{
		path: "/login/code",
		name: "login_code",
		meta: {
			depth: 1
		},
		component: () => import(/* webpackChunkName: "login_code" */ "@/views/web/LoginCode.vue"),
	},
	{
		path: "/subscriptions",
		name: "subscriptions",
		meta: {
			depth: 2
		},
		component: () => import(/* webpackChunkName: "subscriptions" */ "@/views/web/Subscriptions.vue"),
	},
	{
		path: "/subscriptions/detail",
		name: "subscriptions_detail",
		meta: {
			depth: 3
		},
		component: () => import(/* webpackChunkName: "subscriptions_detail" */ "@/views/web/SubscriptionDetail.vue"),
		beforeEnter: protectSubscription
	},
	{
		path: "/subscriptions/detail/add",
		name: "subscriptions_add_products",
		meta: {
			depth: 5
		},
		component: () => import(/* webpackChunkName: "subscriptions_add_products" */ "@/views/web/SubscriptionAddProducts.vue"),
		beforeEnter: protectSubscription
	},
	{
		path: '/mobile',
		name: 'mobile_login',
		alias: '/mobile/login',
		meta: {
			depth: 0
		},
		component: () => import(/* webpackChunkName: "login" */ "@/views/mobile/Login.vue"),
	},
	{
		path: "/mobile/login/code",
		name: "mobile_login_code",
		meta: {
			depth: 1
		},
		component: () => import(/* webpackChunkName: "login_code" */ "@/views/mobile/LoginCode.vue"),
	},
	{
		path: "/mobile/subscriptions",
		name: "mobile_subscriptions",
		meta: {
			depth: 2
		},
		component: () => import(/* webpackChunkName: "subscriptions" */ "@/views/mobile/Subscriptions.vue"),
	},
	{
		path: "/mobile/subscriptions/detail",
		name: "mobile_subscription_detail",
		meta: {
			depth: 3
		},
		component: () => import(/* webpackChunkName: "subscriptions_detail" */ "@/views/mobile/SubscriptionDetail.vue"),
		beforeEnter: protectSubscription
	},
	{
		path: "/mobile/subscriptions/detail/add",
		name: "mobile_subscription_add_products",
		meta: {
			depth: 5
		},
		component: () => import(/* webpackChunkName: "subscriptions_add_products" */ "@/views/mobile/SubscriptionAddProducts.vue"),
		beforeEnter: protectSubscription
	},
	{
		path: "*",
		redirect: { name: "login" }
	}
];

const router = new VueRouter({
	routes
});

router.beforeEach(async (to, from, next) => {
	const fromPath		= from.fullPath;
	const toPath		= to.fullPath;
	const query			= to.query;
	const isMobile		= verifyMobile();
	const isFromLogin	= fromPath.includes("/login");
	const isLoginRoute	= toPath.includes("/login");
	const isCodeRoute	= toPath.includes("/code");
	const isMobileRoute	= toPath.includes("/mobile");

	if (isLoginRoute) {
		if (!isFromLogin) {
			store.commit("auth/setEmail", null);
		}
		store.commit("auth/setCode",	null);
		store.commit("auth/setToken",	null);
	}

	const credentials = store.getters["auth/getCredentials"];

	if(isCodeRoute && !credentials.email){
		next({ name: "login", query });
	} else {
		if(!isLoginRoute && (!credentials.email || !credentials.code || !credentials.token)){
			const { token } = await store.dispatch("auth/startLocalStorage");

			if(token){
				next({ name: "subscriptions", query });
			}else{
				next({ name: "login", query });
			}
		}else{
			if(isMobile){
				if(!isMobileRoute){
					const newPath = "/mobile" + toPath;
					next({ path: newPath, query });
				}else{
					next();
				}
			}else{
				if(isMobileRoute){
					const newPath = toPath.replace("/mobile", "");
					next({ path: newPath, query });
				}else{
					next();
				}
			}
		}
	}
});

export default router;
